module.exports = __webpack_public_path__ + "img/hero-global.ac96f41c.jpg";